/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceCspUnGated } from './serviceCspUnGated';
import { VmcProperties } from './vmcProperties';


export interface VcdsOrgProperties { 
    org_id: string;
    org_name?: string;
    org_type?: string;
    org_type_overridden?: boolean;
    erp_id?: string;
    date_org_found?: Date;
    date_org_properties_updated?: Date;
    date_org_type_updated?: Date;
    csp_ungated?: ServiceCspUnGated;
    vmc_burst_expected?: boolean;
    licensee_classification?: string;
    vmc_properties?: VmcProperties;
}

